import { useTranslation } from "react-i18next";
import { debugLogPages } from "../../app/helpers/debugHelper";
import NavbarIconsGenericComponent from "../generic-nav-bar/NavbarIconsGenericComponent";

const EditorialPolicyScreen = () => {

  debugLogPages(':: EditorialPolicyScreen');
  const { t } = useTranslation();

  return (
    <div className="contenedorBusquedaTextual">
      <NavbarIconsGenericComponent componentName="EndUserEditorialPolicyScreen" />

      {/* Usamos container de Bootstrap para el padding lateral automático y responsive */}
      <div className="container py-5 editorial-policy-sheet" style={{ backgroundColor: "#ffffff" }}>

        {/* Título Centrado */}
        <h2 className="text-center mb-5 fw-bold" style={{ color: "#333" }}>
          {t("general.page.disclosure.title")}
        </h2>

        <div
          className="text-justify"
          style={{
            fontSize: "1.1rem",
            lineHeight: "1.8",
            color: "#000000",
            // Eliminamos maxHeight y overflowY para quitar el scroll interno
          }}
        >
          <p className="mb-4">
            {t("general.page.disclosure.p1")}
          </p>

          <p className="mb-4">
            {t("general.page.disclosure.p2")}
          </p>

          {/* Se eliminaron las clases bg-light, border y fw-bold para uniformidad */}
          <p className="mb-4">
            {t("general.page.disclosure.p3")}
          </p>

          <p className="mb-4">
            {t("general.page.disclosure.p4")}
          </p>

          <p className="mb-4">
            {t("general.page.disclosure.p5")}
          </p>

          <p className="mb-4">
            {t("general.page.disclosure.p6")}
          </p>

          <p className="mb-4">
            {t("general.page.disclosure.p7-start")}
            {/*<strong>{t("general.page.disclosure.p7-email")}</strong>*/}
            <a href={`mailto:${t('general.page.disclosure.p7-email')}`} className="text-primary">
              {t("general.page.disclosure.p7-email")}
            </a>
            {t("general.page.disclosure.p7-end")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default EditorialPolicyScreen;
